
  var _styles = {
  "deal-more-btn": {
    "marginTop": "0.16rem",
    "marginBottom": "0.24rem",
    "width": "3.86667rem",
    "height": "0.86667rem"
  }
};



  module.exports = _styles;
  